// TODO: This file was created by bulk-decaffeinate.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {clamp} from '@benchling/js-utils';
import Backbone from 'backbone';
import * as d3 from 'd3';
import {ScaleLogarithmic} from 'd3';
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import _ from 'underscore';

import {AlignmentComments} from 'analyses/alignment/AlignmentComments';
import GapSequenceWrapper, {GapSequenceWrapperOptions} from 'analyses/alignment/GapSequenceWrapper';
import {Alignment} from 'analyses/Analyses';
import {Permissions} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import GapSequence from 'biojs/GapSequence';
import {Parts, Model as Part} from 'biojs/Part';
import {Sequence} from 'components/Sequence';
import {DNAAlignmentKind} from 'constants/AlignmentConstants';
import * as MapsConstants from 'constants/MapsConstants';
import {SEQUENCE_DEFAULT_ZOOM} from 'constants/MapsConstants';
import {ComplexPolymerType} from 'modbio/complex-polymers/ComplexPolymerConstants';
import Annotation from 'molbio/annotations/backbone/Annotation';
import Annotations from 'molbio/annotations/backbone/Annotations';
import getCircularLayout, {CircularLayout} from 'molbio/maps/circular/CircularLayout';
import * as infinitescroller from 'molbio/maps/linear/InfiniteScroller';
import getLinearLayout, {AminoAcids, DNA, LinearLayout} from 'molbio/maps/linear/LinearLayout';
import Slice from 'molbio/maps/linear/Slice';
import * as mapsutil from 'molbio/maps/MapsUtil';
import Range from 'molbio/maps/selectables/Range';
import {RegionSelectable} from 'molbio/maps/selectables/Selectables';
import Type from 'molbio/maps/Type';
import Protein from 'molbio/proteins/Protein';
import * as sequtil from 'molbio/SeqUtil';
import TranslationAsAnnotation, {
  getTranslationsAsAnnotationsInRange,
} from 'molbio/translations/backbone/TranslationAsAnnotation';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import {MakeAllFieldsOptional} from 'util/Types';

export abstract class PolymerMapState extends Backbone.Model {
  defaults(): {} {
    return {};
  }
}

interface SinglePolymerMapStateAttributes<Polymer extends Protein | Sequence> {
  polymer: Polymer;
  sequence: Polymer;
  protein: Polymer;
  // We want to render a biointelligent link differently on hover. Because a link can cross multiple
  // slices, we need to manage the hovered link state at this level.
  hoveredLinkIndices: {start: number; end: number} | null;
  visibilityOptions: vo.VisibilityOptions;
  // TODO: Narrow
  polymerLayout: {[key: string]: MapsConstants.PolymerLayout};
}

interface SinglePolymerMapState<Polymer extends Protein | Sequence> {
  get<K extends keyof SinglePolymerMapStateAttributes<Polymer>>(
    key: K
  ): SinglePolymerMapStateAttributes<Polymer>[K];

  set<K extends keyof SinglePolymerMapStateAttributes<Polymer>>(
    attributeName: K,
    value: SinglePolymerMapStateAttributes<Polymer>[K],
    options?: Backbone.ModelSetOptions
  ): SinglePolymerMapState<Polymer>;

  set(obj: Partial<SinglePolymerMapStateAttributes<Polymer>>): SinglePolymerMapState<Polymer>;
}

/**
 * Abstract base class for rendering a single polymer map.
 */
abstract class SinglePolymerMapState<Polymer extends Protein | Sequence> extends PolymerMapState {
  initialize(attributes?: unknown, options?: unknown): void {
    // eslint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
    this.setPolymer();
    this.setHoveredLinkIndices(null);
    this.on('change:sequence change:polymer change:protein', this.setPolymer.bind(this));
  }

  setPolymer(): void {
    const polymer = this.polymer() || this.get('sequence') || this.get('protein');
    this.set('sequence', polymer);
    this.set('polymer', polymer);
    this.set('protein', polymer);
  }

  polymer(): Polymer {
    return this.get('polymer');
  }

  sequence<TSequence extends Sequence>(this: SinglePolymerMapState<TSequence>): TSequence {
    return this.polymer();
  }

  protein(this: SinglePolymerMapState<Protein>): Protein {
    return this.polymer();
  }

  hoveredLinkIndices(): {start: number; end: number} | null {
    return this.get('hoveredLinkIndices');
  }

  setHoveredLinkIndices(hoveredLinkIndices: {start: number; end: number} | null): void {
    this.set('hoveredLinkIndices', hoveredLinkIndices);
  }
}

interface AlignmentMapStateAttributes extends SinglePolymerMapStateAttributes<GapSequenceWrapper> {
  alignment: Alignment;
  handleCanEdit: (options?: {isFeatureEdit: boolean}) => boolean;
  layout: LinearLayout;
  editable: boolean;
  layeringMode: MapsConstants.LayeringMode;
  permissions: Permissions;
  // Only defined for the reference sequence row.
  alignmentComments?: AlignmentComments;
  baseSequence?: Sequence;
  // TODO: unclear if these are read anywhere
  width: number;
  height: number;
}

interface AlignmentMapState {
  get<K extends keyof AlignmentMapStateAttributes>(key: K): AlignmentMapStateAttributes[K];

  set<K extends keyof AlignmentMapStateAttributes>(
    attributeName: K,
    value: AlignmentMapStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): AlignmentMapState;

  set(obj: Partial<AlignmentMapStateAttributes>): AlignmentMapState;
}

/**
 * Map state for a single row within a nucleotide alignment.
 *
 * Expected to be contained in a AlignmentMapStates collection.
 */
class AlignmentMapState extends SinglePolymerMapState<GapSequenceWrapper> {
  defaults(): MakeAllFieldsOptional<AlignmentMapStateAttributes> {
    return {
      ...super.defaults(),
      alignment: null,
      layout: getLinearLayout(),
      editable: false,
      visibilityOptions: null,
      layeringMode: MapsConstants.LINEAR_LAYER_FULL,
      polymerLayout: MapsConstants.DEFAULT_ALIGNMENT_LAYOUT,
    };
  }

  initialize(
    attributes?: {
      alignment: Alignment;
      alignmentComments: AlignmentComments;
      baseSequence: Sequence;
      handleCanEdit: (options?: {isFeatureEdit: boolean}) => boolean;
      isInSync: () => boolean;
      permissions?: Permissions;
      visibilityOptoins: vo.VisibilityOptions;
    },
    options?: unknown
  ): void {
    // eslint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
    const args: {
      _sequence: GapSequence;
      baseSequence?: Sequence;
      permissions?: Permissions;
      hasTraceData?: boolean;
    } = {
      _sequence: this.get('alignment').get('sequence'),
    };
    if (attributes!.baseSequence != null) {
      args.baseSequence = attributes!.baseSequence;
    }
    if (attributes!.permissions != null) {
      args.permissions = attributes!.permissions;
    }
    if (this.get('alignment').get('trace') != null) {
      args.hasTraceData = true;
    }

    const argOptions: GapSequenceWrapperOptions = {
      handleCanEdit: attributes!.handleCanEdit,
      isInSync: attributes!.isInSync,
      rotationIndex: this.get('alignment').get('rotationIndex') ?? 0,
    };
    if (this.get('alignment').get('type') !== DNAAlignmentKind.CONSENSUS) {
      argOptions.trimStart = this.get('alignment').get('trimStart');
      argOptions.trimEnd = this.get('alignment').get('trimEnd');
    }

    this.set('sequence', new GapSequenceWrapper(args, argOptions));
  }

  adjustLayoutsForRange(range: Range): void {
    // Given the range that has just been set, see if the corresponding Type would have characters too small
    // to be visible. If so, hide translations.
    const visible = Type.fitToWidth(range.span(), range.get('maxWidth')) != null;
    this.get('layout').Translations.set('visible', visible);
    this.get('layout').Translations.get('single').set('visible', visible);
  }

  isMasterSequence(): boolean {
    const rowType = this.get('alignment').get('type');
    return rowType === DNAAlignmentKind.TEMPLATE || rowType === DNAAlignmentKind.CONSENSUS;
  }
}

class AlignmentMapStates extends Backbone.Collection<AlignmentMapState> {
  static initClass(): void {
    this.prototype.model = AlignmentMapState;
  }
}

AlignmentMapStates.initClass();

interface SummaryMapSingleStateAttributes extends SinglePolymerMapStateAttributes<GapSequenceWrapper> {
  layout: LinearLayout;
  editable: boolean;
}

interface SummaryMapSingleState {
  get<K extends keyof SummaryMapSingleStateAttributes>(key: K): SummaryMapSingleStateAttributes[K];

  set<K extends keyof SummaryMapSingleStateAttributes>(
    attributeName: K,
    value: SummaryMapSingleStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): SummaryMapSingleState;

  set(obj: Partial<SummaryMapSingleStateAttributes>): SummaryMapSingleState;
}

class SummaryMapSingleState extends SinglePolymerMapState<GapSequenceWrapper> {
  defaults(): MakeAllFieldsOptional<SummaryMapSingleStateAttributes> {
    return {
      ...super.defaults(),
      layout: null,
      editable: false,
      visibilityOptions: null,
    };
  }
}

class SummaryMapSingleStates extends Backbone.Collection<SummaryMapSingleState> {
  static initClass(): void {
    this.prototype.model = SummaryMapSingleState;
  }
}

SummaryMapSingleStates.initClass();

interface SummaryMapStateAttributes {
  submapstates: SummaryMapSingleStates;
  visibilityOptions: vo.VisibilityOptions;
  layout: LinearLayout;
  editable: boolean;
  sequences: Array<GapSequenceWrapper>;
  range: Range | null;
  alignmentComments: AlignmentComments;
  sliceHeight?: number;
}

interface SummaryMapState {
  get<K extends keyof SummaryMapStateAttributes>(key: K): SummaryMapStateAttributes[K];

  set<K extends keyof SummaryMapStateAttributes>(
    attributeName: K,
    value: SummaryMapStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): SummaryMapState;

  set(obj: Partial<SummaryMapStateAttributes>): SummaryMapState;
}

/**
 * Map state for rendering the summary map of a nucleotide alignment.
 */
class SummaryMapState extends PolymerMapState {
  defaults(): MakeAllFieldsOptional<SummaryMapStateAttributes> {
    return {
      ...super.defaults(),
      sequences: [],
      layout: getLinearLayout(),
      editable: false,
      range: null,
      submapstates: null,
      alignmentComments: null,
    };
  }

  initialize(): void {
    this.set({
      submapstates: new SummaryMapSingleStates(
        this.get('sequences').map(
          (seq) =>
            new SummaryMapSingleState({
              sequence: seq,
              layout: this.get('layout'),
              editable: this.get('editable'),
              visibilityOptions: this.get('visibilityOptions'),
            })
        )
      ),
    });
  }
}

interface PolymerLinearMapStateAttributes<Polymer extends Protein | Sequence>
  extends SinglePolymerMapStateAttributes<Polymer> {
  zoom: number;
  stepZoom: number;
  minZoom: number;
  maxZoom: number;
  minFontSize: number;
  minVisibleFontSize: number;
  defaultFontSize: number;
  maxFontSize: number;
  topSlice: number;
  sliceOffset: number;
  scrollData: infinitescroller.ScrollData;
  layout: LinearLayout;
  layeringMode: MapsConstants.LayeringMode;
  complexPolymerType?: ComplexPolymerType;
  // The following properties are set by PolymerSliceItemSource
  maxBases: number;
  skipRender?: boolean;
}

interface PolymerLinearMapState<Polymer extends Protein | Sequence> {
  get<K extends keyof PolymerLinearMapStateAttributes<Polymer>>(
    key: K
  ): PolymerLinearMapStateAttributes<Polymer>[K];

  set<K extends keyof PolymerLinearMapStateAttributes<Polymer>>(
    attributeName: K,
    value: PolymerLinearMapStateAttributes<Polymer>[K],
    options?: Backbone.ModelSetOptions
  ): PolymerLinearMapState<Polymer>;

  set(obj: Partial<PolymerLinearMapStateAttributes<Polymer>>): PolymerLinearMapState<Polymer>;
}

abstract class PolymerLinearMapState<
  Polymer extends Protein | Sequence,
> extends SinglePolymerMapState<Polymer> {
  adjustPolymerLayoutsForZoom?({
    newFontSize,
    newLetterSpacing,
    newBaseVisible,
    newZoom,
  }: {
    newFontSize: number;
    newLetterSpacing: number;
    newBaseVisible: boolean;
    newZoom: number;
  }): void;

  defaults(): MakeAllFieldsOptional<PolymerLinearMapStateAttributes<Polymer>> {
    return {
      ...super.defaults(),
      zoom: SEQUENCE_DEFAULT_ZOOM,
      stepZoom: 2,
      maxZoom: MapsConstants.LINEAR_MAX_ZOOM_NO_MODS,
      minFontSize: MapsConstants.NUCLEOTIDE_MIN_FONT_SIZE,
      minVisibleFontSize: MapsConstants.NUCLEOTIDE_MIN_VISIBLE_FONT_SIZE,
      defaultFontSize: MapsConstants.NUCLEOTIDE_DEFAULT_FONT_SIZE,
      maxFontSize: MapsConstants.NUCLEOTIDE_MAX_FONT_SIZE,
      topSlice: 0,
      sliceOffset: 0,
      scrollData: new infinitescroller.ScrollData(),
      layout: getLinearLayout(),
      // polymerLayout is an optional parallel layout data structure using plain objects rather than Backbone
      // models. Recommended for new code that uses React. Currently in use for amino acids, RNA sequences,
      // transcriptions, parts, and oligos. Subclasses that use polymerLayout may need to implement
      // adjustPolymerLayoutsForZoom.
      polymerLayout: {},
      layeringMode: MapsConstants.LINEAR_LAYER_FULL,
    };
  }

  changeZoomByStep(stepChange: number): PolymerLinearMapState<Polymer> {
    const newZoom = this.get('zoom') + stepChange * this.get('stepZoom');
    return this.setZoom(newZoom);
  }

  /**
   * Subclasses can implement this method to intercept the transition between zoom states and override the
   * new value
   */
  overrideZoomChange(oldZoom: number, newZoom: number): number {
    return newZoom;
  }

  /**
   * Set zoom for a mapstate given a target zoom, which is a unitless multiplier of how wide the character
   * is at the default zoom (not a multiplier of the font size). A zoom of 100 is no change from the
   * default. Smaller is smaller font (until a min bound), larger is larger font (until a max bound),
   * after which we increase letter spacing but not character size.
   */
  setZoom(targetZoom: number): PolymerLinearMapState<Polymer> {
    let fontSize;
    let letterSpacing;

    const clampedTargetZoom = clamp(this.get('minZoom'), this.get('maxZoom'), targetZoom);
    const zoom = this.overrideZoomChange(this.get('zoom'), clampedTargetZoom);
    const widths = Type.widths;

    const minFontSize = this.get('minFontSize');
    const maxFontSize = this.get('maxFontSize');

    const normalWidth = widths[this.get('defaultFontSize')];

    /**
     * Note that this scale calculation is equivalent to `normalWidth * (zoom / SEQUENCE_DEFAULT_ZOOM)`
     * but it would be nice to migrate towards having `scale` as a model attribute.
     *
     * An ideal would be:
     * - `setZoom` just performs `this.set('zoom', clamp(this.minZoom(), this.maxZoom(), zoom));`
     *   and any map states that need to adjust font widths or letter spacings can do so in a listener
     * - minZoom and maxZoom attributes become extraneous because they are captured in the domain of the scale
     *   (see MiniMapState as an example)
     * - calculating the invert becomes cleaner - `getProteinMinZoom` can just invert the min font size
     */
    const scale = d3.scaleLinear(
      [this.get('minZoom'), this.get('maxZoom')],
      [
        normalWidth * (this.get('minZoom') / SEQUENCE_DEFAULT_ZOOM),
        normalWidth * (this.get('maxZoom') / SEQUENCE_DEFAULT_ZOOM),
      ]
    );
    const targetWidth = scale(zoom);
    const visible = targetWidth >= widths[this.get('minVisibleFontSize')];

    // Pick that most closely matches the desired width, and adjust letter spacing to make up for the rest
    if (targetWidth < widths[minFontSize]) {
      fontSize = minFontSize;
      letterSpacing = 0;
    } else if (targetWidth > widths[maxFontSize]) {
      fontSize = maxFontSize;
      letterSpacing = targetWidth - widths[maxFontSize];
    } else {
      let size;
      fontSize = maxFontSize;
      for (size = minFontSize; size < maxFontSize; size++) {
        if (widths[size + 1] > targetWidth) {
          fontSize = size;
          break;
        }
      }
      letterSpacing = targetWidth - widths[size];
    }
    this.adjustLayoutsForZoom({
      newFontSize: fontSize,
      newLetterSpacing: letterSpacing,
      newBaseVisible: visible,
      newZoom: zoom,
    });
    return this.set('zoom', zoom);
  }

  /**
   * Responsible for updating layout objects to reflect the new zoom level.
   * @param newFontSize - Font size at new zoom level.
   * @param newLetterSpacing - Letter spacing at new zoom level.
   * @param newBaseVisible - Whether bases are visible at the new zoom level.
   * @param newZoom - New zoom value.
   */
  adjustLayoutsForZoom({
    newFontSize,
    newLetterSpacing,
    newBaseVisible,
    newZoom,
  }: {
    newFontSize: number;
    newLetterSpacing: number;
    newBaseVisible: boolean;
    newZoom: number;
  }): void {
    // Workaround for TS error  "... none of those signatures are compatible with each other"
    interface MergedLayout {
      get(key: 'type'): Type;
      set(key: 'visible', value: boolean): MergedLayout;
    }

    const residuesLayout: MergedLayout = this.getResiduesLayout();

    residuesLayout.get('type').setFontSize(newFontSize);
    residuesLayout.get('type').setLetterSpacing(Math.ceil(newLetterSpacing));
    residuesLayout.set('visible', newBaseVisible);
    // Update polymerLayout to be consistent with layout
    if (typeof this.adjustPolymerLayoutsForZoom === 'function') {
      this.adjustPolymerLayoutsForZoom({newFontSize, newLetterSpacing, newBaseVisible, newZoom});
    }
  }

  abstract getResiduesLayout(): Polymer extends Sequence ? DNA : AminoAcids;
}

interface ProteinLinearMapStateAttributes extends PolymerLinearMapStateAttributes<Protein> {
  // This is needed to be compatible with `PolymerAnnotationsViewModel` - unclear if it
  // actually gets set.
  inlineLabelPadding: number;
}

interface ProteinLinearMapState {
  get<K extends keyof ProteinLinearMapStateAttributes>(key: K): ProteinLinearMapStateAttributes[K];

  set<K extends keyof ProteinLinearMapStateAttributes>(
    attributeName: K,
    value: ProteinLinearMapStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): ProteinLinearMapState;

  set(obj: Partial<ProteinLinearMapStateAttributes>): ProteinLinearMapState;
}

class ProteinLinearMapState extends PolymerLinearMapState<Protein> {
  defaults(): MakeAllFieldsOptional<ProteinLinearMapStateAttributes> {
    return {
      ...super.defaults(),
      minZoom: MapsConstants.PROTEIN_MIN_ZOOM,
      // Amino acid residues should always be visible
      minFontSize: MapsConstants.AMINO_ACID_MIN_VISIBLE_FONT_SIZE,
      minVisibleFontSize: MapsConstants.AMINO_ACID_MIN_VISIBLE_FONT_SIZE,
      defaultFontSize: MapsConstants.AMINO_ACID_DEFAULT_FONT_SIZE,
      maxFontSize: MapsConstants.AMINO_ACID_MAX_FONT_SIZE,
      // polymerLayout duplicates all the layout information that 'layout' contains for amino acids.
      // This duplication is necessary so that the polymerLayout can be passed as a prop to React components,
      // but existing Backbone components can still listen to layout.
      // However, the visibility options are stored only in polymerLayout.
      // @ts-expect-error polymerLayout expects an object with arbitrary string indices and ProteinLayout is narrower
      polymerLayout: MapsConstants.getDefaultProteinLayout(),
    };
  }

  initialize(): void {
    // eslint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
    this.listenTo(this.get('visibilityOptions'), 'redraw', this.syncVisibilityOptions.bind(this));
    this.syncVisibilityOptions();
  }

  syncVisibilityOptions(): void {
    const coloringOption = this.get('visibilityOptions').getOption(vo.PROTEIN_COLORING.name)!;
    const newPolymerLayout = reactUpdate(this.get('polymerLayout'), {
      aminoAcids: {
        foregroundColoring: {
          $set: coloringOption.getSetting(vo.getProteinColoringSetting().name)!.get('value'),
        },
        showColoring: {$set: coloringOption.get('visible')},
      },
    });
    this.set({polymerLayout: newPolymerLayout});
  }

  getResiduesLayout(): AminoAcids {
    return this.get('layout').AminoAcids;
  }

  adjustPolymerLayoutsForZoom({
    newFontSize,
    newLetterSpacing,
    newBaseVisible,
  }: {
    newFontSize: number;
    newLetterSpacing: number;
    newBaseVisible: boolean;
  }): void {
    const newPolymerLayout = reactUpdate(this.get('polymerLayout'), {
      aminoAcids: {
        $merge: {
          type: {
            fontSize: newFontSize,
            letterSpacing: Math.ceil(newLetterSpacing),
          },
          visible: newBaseVisible,
        },
      },
    });
    this.set({polymerLayout: newPolymerLayout});
  }
}

type SequenceLinearMapStateAttributes = PolymerLinearMapStateAttributes<Sequence>;

interface SequenceLinearMapState {
  get<K extends keyof SequenceLinearMapStateAttributes>(key: K): SequenceLinearMapStateAttributes[K];

  set<K extends keyof SequenceLinearMapStateAttributes>(
    attributeName: K,
    value: SequenceLinearMapStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): SequenceLinearMapState;

  set(obj: Partial<SequenceLinearMapStateAttributes>): SequenceLinearMapState;
}

class SequenceLinearMapState extends PolymerLinearMapState<Sequence> {
  defaults(): MakeAllFieldsOptional<SequenceLinearMapStateAttributes> {
    return {
      ...super.defaults(),
      minZoom: MapsConstants.NUCLEOTIDE_SEQUENCE_MIN_ZOOM,
      polymerLayout: MapsConstants.DEFAULT_DNA_SEQUENCE_LAYOUT,
    };
  }

  initialize(attributes?: unknown, options?: unknown): void {
    // eslint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
  }

  getResiduesLayout(): DNA {
    return this.get('layout').DNA;
  }

  adjustLayoutsForZoom(options: {
    newFontSize: number;
    newLetterSpacing: number;
    newBaseVisible: boolean;
    newZoom: number;
  }): void {
    super.adjustLayoutsForZoom(options);
    // Bases disappear on higher zoom levels in the linear sequence map. This code configures transcriptions
    // and translations to disappear and reappear at the same zoom level as bases.
    this.get('layout').Translations.set('visible', options.newBaseVisible);
    const dnaFontSize = this.getResiduesLayout().get('type').fontSize;
    const oldPolymerLayout = this.get('polymerLayout');
    const newPolymerLayout = {
      ...oldPolymerLayout,
      forwardTranscriptionLine: {
        ...oldPolymerLayout.forwardTranscriptionLine,
        visible: options.newBaseVisible,
        svgHeight: dnaFontSize * MapsConstants.TRANSCRIPTION_LINE_HEIGHT_SCALE,
      },
      reverseTranscriptionLine: {
        ...oldPolymerLayout.reverseTranscriptionLine,
        visible: options.newBaseVisible,
        svgHeight: dnaFontSize * MapsConstants.TRANSCRIPTION_LINE_HEIGHT_SCALE,
      },
      transcriptionArrow: {
        ...oldPolymerLayout.transcriptionArrow,
        visible: options.newBaseVisible,
      },
    };
    this.set({polymerLayout: newPolymerLayout});
  }
}

class RNASequenceLinearMapState extends SequenceLinearMapState {
  defaults(): MakeAllFieldsOptional<SequenceLinearMapStateAttributes> {
    return {
      ...super.defaults(),
      maxZoom: BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES
        ? MapsConstants.DETAILED_NUCLEOTIDE_SEQUENCE_STATIC_ZOOM
        : MapsConstants.LINEAR_MAX_ZOOM_NO_MODS,
      polymerLayout: MapsConstants.DEFAULT_RNA_SEQUENCE_LAYOUT,
    };
  }

  /**
   * Implements a step-change jump between the max zoom for the traditional sequence map (300) and the min
   * zoom for the mod-aware map (400). If the incoming target zoom is between these two values, we return
   * a "rounded" value based on the direction of travel (zooming in or zooming out).
   */
  overrideZoomChange(oldZoom: number, newZoom: number): number {
    if (
      newZoom > MapsConstants.LINEAR_MAX_ZOOM_NO_MODS &&
      newZoom < MapsConstants.DETAILED_NUCLEOTIDE_SEQUENCE_STATIC_ZOOM
    ) {
      return oldZoom > newZoom
        ? MapsConstants.LINEAR_MAX_ZOOM_NO_MODS
        : MapsConstants.DETAILED_NUCLEOTIDE_SEQUENCE_STATIC_ZOOM;
    }
    return newZoom;
  }

  adjustLayoutsForZoom(options: {
    newFontSize: number;
    newLetterSpacing: number;
    newBaseVisible: boolean;
    newZoom: number;
  }): void {
    super.adjustLayoutsForZoom(options);
    this.getResiduesLayout().set({
      detailedView: options.newZoom >= MapsConstants.DETAILED_NUCLEOTIDE_SEQUENCE_STATIC_ZOOM,
    });
  }

  adjustPolymerLayoutsForZoom({newZoom}: {newZoom: number}): void {
    const oldPolymerLayout = this.get('polymerLayout');
    const newPolymerLayout = {
      ...oldPolymerLayout,
      modifiedNucleotides: {
        ...oldPolymerLayout.modifiedNucleotides,
        visible:
          newZoom >= MapsConstants.DETAILED_NUCLEOTIDE_SEQUENCE_STATIC_ZOOM &&
          BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES,
      },
    };
    this.set({polymerLayout: newPolymerLayout});
  }
}

type OligoLinearMapStateAttributes = PolymerLinearMapStateAttributes<Sequence>;

interface OligoLinearMapState {
  get<K extends keyof OligoLinearMapStateAttributes>(key: K): OligoLinearMapStateAttributes[K];

  set<K extends keyof OligoLinearMapStateAttributes>(
    attributeName: K,
    value: OligoLinearMapStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): OligoLinearMapState;

  set(obj: Partial<OligoLinearMapStateAttributes>): OligoLinearMapState;
}

class OligoLinearMapState extends PolymerLinearMapState<Sequence> {
  defaults(): MakeAllFieldsOptional<PolymerLinearMapStateAttributes<Sequence>> {
    return {
      ...super.defaults(),
      // Don't allow zoom adjustments for oligos
      minZoom: MapsConstants.DETAILED_NUCLEOTIDE_SEQUENCE_STATIC_ZOOM,
      maxZoom: MapsConstants.DETAILED_NUCLEOTIDE_SEQUENCE_STATIC_ZOOM,
      polymerLayout: MapsConstants.DEFAULT_OLIGO_LAYOUT,
    };
  }

  initialize(attributes?: unknown, options?: unknown): void {
    super.initialize(attributes, options);
    this.setZoom(MapsConstants.DETAILED_NUCLEOTIDE_SEQUENCE_STATIC_ZOOM);
  }

  getResiduesLayout(): DNA {
    return this.get('layout').DNA;
  }
}

interface CircularMapStateAttributes extends SinglePolymerMapStateAttributes<Sequence> {
  zoom: number;
  isDefault: boolean;
  stepZoom: number;
  stepPan: number;
  minInnerRadius: number;
  cutoffRadius: number;
  minZoom: number;
  maxZoom: number;
  cutoffZoom: number;
  layout: CircularLayout;
  fullCircleView: boolean;
  leftBP: number;
  rightBP: number;
  DNAOffset: number;
  height: number | null;
  width: number | null;
  cx: number | null;
  cy: number | null;
  minRadius: number;
  maxRadius: number;
  // Annotation counts.
  shownA?: number;
  visibleA?: number;
  totalA?: number;
  // Translation counts
  shownTranslations?: number;
  visibleTranslations?: number;
  totalTranslations?: number;
  // Primer params
  primerCutoffRadius?: number;
}

interface CircularMapState {
  get<K extends keyof CircularMapStateAttributes>(key: K): CircularMapStateAttributes[K];

  set<K extends keyof CircularMapStateAttributes>(
    attributeName: K,
    value: CircularMapStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): CircularMapState;

  set(obj: Partial<CircularMapStateAttributes>): CircularMapState;
}

class CircularMapState extends SinglePolymerMapState<Sequence> {
  defaults(): MakeAllFieldsOptional<CircularMapStateAttributes> {
    return {
      ...super.defaults(),
      zoom: 0.5,
      isDefault: true,
      stepZoom: 0.01,
      stepPan: 1,
      minInnerRadius: 40,
      cutoffRadius: 300,
      minZoom: 0,
      maxZoom: 1,
      cutoffZoom: 0.2,
      layout: getCircularLayout(),
      fullCircleView: true,
      leftBP: 0,
      rightBP: 0,
      sequence: null,
      DNAOffset: 0,
      height: null,
      width: null,
      cx: null, // center x
      cy: null, // center y
    };
  }

  initialize(): void {
    // eslint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
    const visibilityOptions = this.get('visibilityOptions');
    const showInlineLabels = visibilityOptions.getOption(vo.INLINE_LABELS.name);

    this.listenTo(showInlineLabels, 'change:visible', this.updateLabelShow.bind(this));
    this.listenTo(visibilityOptions, 'change:visible', this.updateShow.bind(this));
    this.updateLabelShow();
    this.updateShow();
  }

  updateLabelShow(): void {
    const visibilityOptions = this.get('visibilityOptions');
    const value = visibilityOptions.getOption(vo.INLINE_LABELS.name)!.get('visible');
    this.get('layout').CircularAnnotationsLayout.set('inlineLabelsVisible', value);
    this.get('layout').CircularTranslationsLayout.set('inlineLabelsVisible', value);
    this.get('layout').CircularPartAnnotationsLayout.set('inlineLabelsVisible', value);
    this.get('layout').CircularPrimersLayout.set('inlineLabelsVisible', value);
    this.trigger('invalidateLayers');
    this.trigger('redraw');
  }

  updateShow(): void {
    const visibilityOptions = this.get('visibilityOptions');
    const showAnnotations = visibilityOptions.getOption(vo.ANNOTATIONS.name)!.get('visible');
    const showTranslations = visibilityOptions.getOption(vo.TRANSLATIONS.name)!.get('visible');
    const showPartAnnotations =
      visibilityOptions.getOption(vo.PART_ANNOTATIONS.name)?.get('visible') ?? false;
    const showORFs = visibilityOptions.getOption(vo.ORFS.name)!.get('visible');
    const showPrimers = visibilityOptions.getOption(vo.PRIMERS.name)!.get('visible');
    const showCutSites = visibilityOptions.getOption(vo.CUTSITES.name)!.get('visible');
    const showAxis = visibilityOptions.getOption(vo.SEQUENCE_AXIS.name)!.get('visible');
    const showHomologyAxis = visibilityOptions.getOption(vo.HOMOLOGY_REGION_AXIS.name)!.get('visible');
    const showDNA = visibilityOptions.getOption(vo.DNA.name)!.get('visible');
    const showHomologyDNA = visibilityOptions.getOption(vo.HOMOLOGY_REGION_DNA.name)!.get('visible');

    const layout = this.get('layout');
    layout.CircularAnnotationsLayout.set('visible', showAnnotations);
    layout.CircularTranslationsLayout.set('visible', showTranslations);
    layout.CircularPartAnnotationsLayout.set('visible', showPartAnnotations);
    layout.CircularPrimersLayout.set('visible', showPrimers);
    layout.CircularORFsLayout.set('visible', showORFs);
    layout.AxisLayout.set('visible', showAxis);
    layout.HomologyAxisLayout.set('visible', showHomologyAxis);
    layout.DNALayout.set('visible', showDNA);
    layout.HomologyDNALayout.set('visible', showHomologyDNA);
    layout.LabelLayout.set('annotationsVisible', showAnnotations);
    layout.LabelLayout.set('translationsVisible', showTranslations);
    layout.LabelLayout.set('partAnnotationsVisible', showPartAnnotations);
    layout.LabelLayout.set('primersVisible', showPrimers);
    layout.LabelLayout.set('cutSitesVisible', showCutSites);
  }

  getRadius(): number {
    return this.zoomToRadius(this.get('zoom'));
  }

  zoomToRadius(zoom: number): number {
    const cr = this.get('cutoffRadius');
    const cz = this.get('cutoffZoom');
    const min = this.get('minRadius');
    const max = this.get('maxRadius');

    const val = (() => {
      let f;
      // Display the entirety of the circle in this case.
      if (zoom < cz) {
        f = Math.pow(zoom / cz, 1 / 1);
        return f * (cr - min) + min;
      } else {
        /**
         * Documenting the math using scales, but not actually using it to avoid any perf risk. Ideally
         * the scales would be attributes that are only recalculated as necessary. The minZoom, maxZoom,
         * and cutoffZoom values are static, so only the final linear mapping scale would need to be re-computed
         * when the radius changes.

         // Arbitrary range used as a scaling factor.
         const factorRange = [0, 1];
         // Remap this zoom range subset [cutoffZoom, maxZoom] to the full zoom range [minZoom, maxZoom] (i.e. [0.2, 1] to [0, 1])
         const adjustmentScale = d3.scaleLinear(
         [this.get('cutoffZoom'), this.get('maxZoom')],
         [this.get('minZoom'), this.get('maxZoom')]
         );
         // Use power scale to calculate a linear factor of the radius.
         const factorScale = d3.scalePow([this.get('minZoom'), this.get('maxZoom')], factorRange).exponent(2);
         // Remap [0, 1] radius factor to [cutoffRadius, maxRadius]
         const radiusScale = d3.scaleLinear(factorRange, [cr, max]);
         const result = radiusScale(factorScale(adjustmentScale(zoom)));
         */
        f = 1 - Math.pow((zoom - cz) / (1 - cz), 2);
        return max - f * (max - cr);
      }
    })();
    return val;
  }

  radiusToZoom(radius: number): number {
    const cr = this.get('cutoffRadius');
    const cz = this.get('cutoffZoom');
    const min = this.get('minRadius');
    const max = this.get('maxRadius');

    const val = (() => {
      let f;
      if (radius < cr) {
        f = (radius - min) / (cr - min);
        return Math.pow(f, 1) * cz;
      } else if (radius > cr) {
        /**
         * This logic can be replaced using `invert` calls to the scales sketched out in zoomToRadius.
         *
         * Applying them in reverse, it would look like:
         * return adjustmentScale.invert(factorScale.invert(radiusScale.invert(radius)));
         *
         * Verified that the math calculates the same values as the current logic.
         */
        f = 1 - (max - radius) / (max - cr);
        return cz + Math.pow(f, 1 / 2) * (1 - cz);
      } else {
        return cz;
      }
    })();
    return val;
  }

  adjustCutoff(): void {
    const min = this.get('minRadius');
    const max = this.get('maxRadius');

    // FIXME: On initial load, cutoffRadius is set to NaN as max is undefined,
    // but before it gets used, we set max, so it's okay.
    // Probably better to set them all at the same time on initial load.

    if (min === undefined || max === undefined) {
      return;
    }

    if (min < 300 && 300 < max) {
      this.set('cutoffRadius', 300);
    } else {
      this.set('cutoffRadius', min + (max - min) * this.get('cutoffZoom'));
    }
  }

  setMaxRadius(radius: number, silent: boolean): void {
    radius = Math.max(this.get('minRadius') + 10, radius);
    if (silent) {
      this.set({maxRadius: radius});
      this.adjustCutoff();
      return;
    }

    const currentRadius = this.zoomToRadius(this.get('zoom'));
    this.set({maxRadius: radius});
    this.adjustCutoff();

    const newZoom = this.radiusToZoom(currentRadius);
    this.setZoom(newZoom);
  }

  setMinRadius(radius: number, silent: boolean): void {
    if (silent) {
      this.set({minRadius: radius});
      this.adjustCutoff();
      return;
    }
    const currentRadius = this.zoomToRadius(this.get('zoom'));
    this.set({minRadius: radius});
    this.adjustCutoff();
    const newZoom = this.radiusToZoom(currentRadius);
    this.setZoom(newZoom);
  }

  smoothChangePanByStep(stepChange: number): JQuery {
    const length = this.get('sequence').length();
    const oldPan = (this.get('DNAOffset') + length) % length;

    const newPan = (oldPan + stepChange * this.get('stepPan')) % length;
    const target1 = newPan - length;
    const target2 = newPan + length;
    const target = _.min([newPan, target1, target2], (t) => Math.abs(oldPan - t));

    return $({offset: oldPan}).animate(
      {offset: target},
      {
        duration: 100,
        step: ((ref) =>
          function () {
            // @ts-expect-error
            return ref.setOffset(this.offset);
          })(this),
      }
    );
  }

  changePanByStep(stepChange: number): void {
    const newPan = this.get('DNAOffset') + stepChange * this.get('stepPan');
    this.setOffset(newPan);
  }

  smoothZoomByStep(stepChange: number, stepZoom: number | null = null): JQuery {
    if (stepZoom == null) {
      stepZoom = this.get('stepZoom');
    }
    const oldZoom = this.get('zoom');
    const newZoom = oldZoom + stepChange * stepZoom;
    return $({currentZoom: oldZoom}).animate(
      {currentZoom: newZoom},
      {
        duration: 100,
        step: ((ref) =>
          function () {
            // @ts-expect-error
            return ref.setZoom(this.currentZoom);
          })(this),
        complete: (
          (ref) => () =>
            ref.setZoom(newZoom)
        )(this),
      }
    );
  }

  changeZoomByStep(stepChange: number): SinglePolymerMapState<Sequence> {
    const newZoom = this.get('zoom') + stepChange * this.get('stepZoom');
    return this.setZoom(newZoom);
  }

  setZoom(targetZoom: number): SinglePolymerMapState<Sequence> {
    const zoom = clamp(this.get('minZoom'), this.get('maxZoom'), targetZoom);
    return this.set('zoom', zoom);
  }

  setOffset(offset: number): SinglePolymerMapState<Sequence> {
    const length = this.get('sequence').length();
    if (length === 0) {
      offset = 0;
    } else {
      offset %= length;
      if (offset < -length / 2) {
        offset += length;
      }
      if (offset > length / 2) {
        offset -= length;
      }
    }
    return this.set('DNAOffset', offset);
  }
}

interface GenericAnnotation extends RegionSelectable<Sequence> {
  name(): string;
}

interface MiniMapStateAttributes extends SinglePolymerMapStateAttributes<Sequence> {
  fontWidthZoom: number;
  zoomEnabled: boolean;
  // A D3 scale mapping pixel width to zoom value. Note that zoom values
  // for the MiniMap range from [0, 1] which is very different than our other
  // map zoom systems.
  scale: ScaleLogarithmic<number, number>;
  zoom: number;
  stepZoom: number;
  layout: LinearLayout;
  layeringMode: MapsConstants.LayeringMode;
  leftBP: number;
  rightBP: number;
  inlineLabelPadding: number;
  // Annotation counts
  shownA?: number;
  visibleA?: number;
  totalA?: number;
  // Translation counts
  shownTranslations?: number;
  visibleTranslations?: number;
  totalTranslations?: number;
}

interface MiniMapState {
  get<K extends keyof MiniMapStateAttributes>(key: K): MiniMapStateAttributes[K];

  set<K extends keyof MiniMapStateAttributes>(
    attributeName: K,
    value: MiniMapStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): MiniMapState;

  set(obj: Partial<MiniMapStateAttributes>): MiniMapState;
}

class MiniMapState extends SinglePolymerMapState<Sequence> {
  inlineLayeringMode!: MapsConstants.LayeringMode;

  initialize(attributes?: unknown, options?: {inlineLayeringMode: MapsConstants.LayeringMode}): void {
    // eslint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
    this.get('layout').DNA.set({visible: false});
    const visibilityOptions = this.get('visibilityOptions');
    const showInlineLabels = visibilityOptions.getOption(vo.INLINE_LABELS.name);
    this.listenTo(showInlineLabels, 'change:visible', this.updateLabelShow.bind(this));
    this.inlineLayeringMode =
      (options != null ? options.inlineLayeringMode : undefined) || MapsConstants.LINEAR_LAYER_INLINE;
    this.updateLabelShow();
  }

  updateLabelShow(): void {
    const showInlineLabels = this.get('visibilityOptions').getOption(vo.INLINE_LABELS.name)!;
    const showInline = showInlineLabels.get('visible');
    const layeringMode = showInline ? this.inlineLayeringMode : MapsConstants.LINEAR_LAYER_FULL;
    this.set({layeringMode});
  }

  defaults(): MakeAllFieldsOptional<MiniMapStateAttributes> {
    return {
      ...super.defaults(),
      fontWidthZoom: 0,
      zoomEnabled: true,
      scale: d3.scaleLog().range([0, 1]), // px --> zoom
      zoom: 0,
      stepZoom: 0.01,
      layout: getLinearLayout(),
      layeringMode: MapsConstants.LINEAR_LAYER_FULL,
      sequence: null,
      leftBP: 0,
      inlineLabelPadding: 2, // px
      polymerLayout: MapsConstants.DEFAULT_DNA_SEQUENCE_LAYOUT,
    };
  }

  zoomByFactor(factor: number): SinglePolymerMapState<Sequence> {
    return this.setFontWidth(this.getFontWidth() * factor);
  }

  updateLayout(fontWidth: number): void {
    this.get('layout').DNA.get('type').setWidth(fontWidth);
  }

  setZoom(zoom: number): SinglePolymerMapState<Sequence> {
    const scale = this.get('scale');
    zoom = clamp(this.getMinZoom(), this.getMaxZoom(), zoom);
    const fontWidth = scale.invert(zoom);
    this.updateLayout(fontWidth);
    return this.set({zoom, fontWidthZoom: fontWidth});
  }

  setFontWidth(fontWidth: number): SinglePolymerMapState<Sequence> {
    const scale = this.get('scale');
    fontWidth = clamp(this.getMinFontWidth(), this.getMaxFontWidth(), fontWidth);
    const zoom = scale(fontWidth);
    this.updateLayout(fontWidth);
    return this.set({zoom, fontWidthZoom: fontWidth});
  }

  setFontWidthRange(minWidth: number, maxWidth: number): SinglePolymerMapState<Sequence> {
    // Maintain original fontWidth or original zoomedoutedness.
    let fontWidth = this.getFontWidth();
    const zoomedOut = fontWidth === this.getMinFontWidth();
    fontWidth = zoomedOut ? minWidth : clamp(minWidth, maxWidth, fontWidth);
    this.get('scale').domain([minWidth, maxWidth]);
    this.setFontWidth(fontWidth);
    return this.set('zoomEnabled', minWidth !== maxWidth);
  }

  getMinZoom(): number {
    return this.get('scale').range()[0];
  }

  getMaxZoom(): number {
    return this.get('scale').range()[1];
  }

  getMinFontWidth(): number {
    return this.get('scale').domain()[0];
  }

  getMaxFontWidth(): number {
    return this.get('scale').domain()[1];
  }

  getFontWidth(): number {
    return this.get('fontWidthZoom');
  }

  getZoom(): number {
    return this.get('zoom');
  }

  getStepZoom(): number {
    return this.get('stepZoom');
  }

  inlineAnnotationLabelPlacement<T extends GenericAnnotation>(
    model: T,
    slice: Slice
  ): 'after' | 'before' | 'none' {
    const xInv = slice.get('xInv')!;
    const margin = xInv(5); // Maintain at least 5px from either end of the slice.
    const padding = xInv(this.get('inlineLabelPadding'));
    const type = this.get('layout').Annotations.get('type');
    const labelWidth = xInv(type.width(model.name().length)) + padding;

    // Ideally, place the label after the end of the annotation.
    const endPos = sequtil.modelEndToRender(
      model.layerEnd(this.get('sequence')),
      this.get('sequence').length()
    );
    const spaceAfter = endPos + labelWidth < this.get('sequence').length() - margin;
    if (spaceAfter) {
      return 'after';
    }

    // If there isn't sufficient space, we try to place the label before the beginning of the annotation.
    const spaceBefore = model.layerStart(this.get('sequence')) - labelWidth > margin;
    if (spaceBefore) {
      return 'before';
    }

    // If neither works, we don't place a label; the caller should use a tooltip
    return 'none';
  }

  setInlineLayers(slice: Slice): void {
    let labelWidth;
    let padding;
    let placement;
    const sequence = this.get('sequence');
    const type = this.get('layout').Annotations.get('type');
    const xInv = slice.get('xInv')!;
    const textWidth = <T extends GenericAnnotation>(model: T): number =>
      xInv(type.width(model.name().length));
    const startFn = <T extends GenericAnnotation>(model: T): {model: T; pos: number} => {
      placement = this.inlineAnnotationLabelPlacement(model, slice);
      padding = xInv(this.get('inlineLabelPadding'));
      let start = model.layerStart(sequence);
      if (placement === 'before') {
        labelWidth = textWidth(model) + padding;
        start -= labelWidth;
      }
      return {
        model,
        pos: start,
      };
    };
    const endFn = <T extends GenericAnnotation>(model: T): {model: T; pos: number} => {
      placement = this.inlineAnnotationLabelPlacement(model, slice);
      padding = xInv(this.get('inlineLabelPadding'));
      let end = model.layerEnd();
      // NB: Don't handle end=0 because maps/mapsutil uses that as a signal for special casing.
      if (placement === 'after' && end !== 0) {
        labelWidth = textWidth(model) + padding;
        end += labelWidth;
      }
      return {
        model,
        pos: end,
      };
    };
    const annotationModelsAndLayers = mapsutil.getModelLayers<Annotation>(this.getAnnotations(slice).shown, {
      startFn,
      endFn,
      top: false,
    });
    for (const {model, layer} of annotationModelsAndLayers) {
      model.set(this.inlineLayeringMode, layer, {silent: true});
    }
    // When precomputing layer/tiling information for translations on the linear map, we
    // need to use the TranslationAsAnnotation model so that the name is properly computed
    // from the translation group information. The underlying layer number is still stored
    // on the molbio/translation/backbone/Translation model so that it can be accessed later.
    const translationModelsAndLayers = mapsutil.getModelLayers<TranslationAsAnnotation>(
      getTranslationsAsAnnotationsInRange(this.get('sequence'), slice.get('leftBP')!, slice.get('rightBP')!)
        .shownTranslations,
      {
        startFn,
        endFn,
        top: false,
      }
    );
    for (const {model, layer} of translationModelsAndLayers) {
      model.get('translationComponentModel').set(this.inlineLayeringMode, layer, {silent: true});
    }
    const partAnnotationModelsAndLayers = mapsutil.getModelLayers<Part>(
      this.getPartAnnotations(slice).shown,
      {
        startFn,
        endFn,
        top: false,
      }
    );
    for (const {model, layer} of partAnnotationModelsAndLayers) {
      model.set(this.inlineLayeringMode, layer, {silent: true});
    }
  }

  getAnnotations(slice: Slice): {total: Annotations; visible: Array<Annotation>; shown: Array<Annotation>} {
    const sequence = this.get('sequence');
    const total = sequence.annotations();
    let visible: Array<Annotation> = [];
    // @ts-expect-error
    const shown = total.slice(slice.get('leftBP'), slice.get('rightB'), (data: Array<Annotation>) => {
      visible = data;
      return _.sortBy(data, (a) => -a.length(sequence)).slice(0, 100);
    });
    return {total, visible, shown};
  }

  getPartAnnotations(slice: Slice): {total: Parts; visible: Array<Part>; shown: Array<Part>} {
    const sequence = this.get('sequence');
    const total = sequence.parts();
    let visible: Array<Part> = [];
    // @ts-expect-error
    const shown = total.slice(slice.get('leftBP'), slice.get('rightBP'), (data: Array<Part>) => {
      visible = data;
      return _.sortBy(data, (a) => -a.length(sequence)).slice(0, 100);
    });
    return {total, visible, shown};
  }
}

export {
  SinglePolymerMapState,
  AlignmentMapState,
  SummaryMapState,
  AlignmentMapStates,
  PolymerLinearMapState,
  ProteinLinearMapState,
  SequenceLinearMapState,
  RNASequenceLinearMapState,
  OligoLinearMapState,
  CircularMapState,
  MiniMapState,
  SummaryMapSingleState,
};
